import type { ReactNode } from 'react'
import IconDescription from '@/shared/icons/NewDesign/IconDescription'
import IconForum from '@/shared/icons/NewDesign/IconForum'
import IconMail from '@/shared/icons/NewDesign/IconMail'
import IconOpenInNew from '@/shared/icons/NewDesign/IconOpenInNew'
import IconSchool from '@/shared/icons/NewDesign/IconSchool'
import type { ResourceItem } from './useSalePanels'
import { ResourceGo, ResourceRow, ResourceText, ResourceTile } from './styled-components'

const RESOURCE_ICONS: Record<string, ReactNode> = {
  learning_link: <IconSchool size={20} />,
  sale_script: <IconDescription size={20} />,
  email_template_link: <IconMail size={20} />,
  objections: <IconForum size={20} />,
}

interface ResourceListProps {
  resources: ResourceItem[]
}

const ResourceList = ({ resources }: ResourceListProps) => (
  <>
    {resources.map(resource => (
      <ResourceRow key={resource.type} type='button' onClick={resource.onOpen}>
        <ResourceTile>{RESOURCE_ICONS[resource.type]}</ResourceTile>
        <ResourceText>{resource.title}</ResourceText>
        <ResourceGo>
          <IconOpenInNew size={18} />
        </ResourceGo>
      </ResourceRow>
    ))}
  </>
)

export default ResourceList
